import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Footprints, LogIn, UserPlus, MapPin, Phone, Mail } from "lucide-react";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Navigation */}
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Footprints className="w-8 h-8 text-[#0F766E]" />
            <span className="text-xl font-bold text-[#0F766E] font-['Manrope']">
              Ortho Canada Lab
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/login">
              <Button variant="ghost" className="text-slate-600 hover:text-[#0F766E]" data-testid="nav-login-btn">
                <LogIn className="w-4 h-4 mr-2" />
                Login
              </Button>
            </Link>
            <Link to="/register">
              <Button className="bg-[#0F766E] hover:bg-[#115E59]" data-testid="nav-register-btn">
                <UserPlus className="w-4 h-4 mr-2" />
                Register
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-lg w-full">
          <Card className="border-slate-200 shadow-lg overflow-hidden">
            {/* Red accent bar */}
            <div className="h-1.5 bg-gradient-to-r from-[#DC2626] via-[#0F766E] to-[#DC2626]"></div>
            <CardContent className="p-10 text-center">
              <div className="mb-8">
                <div className="mx-auto w-16 h-16 rounded-full bg-[#F0FDFA] flex items-center justify-center mb-6 ring-4 ring-[#DC2626]/10">
                  <Footprints className="w-8 h-8 text-[#0F766E]" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900 font-['Manrope'] mb-2">
                  Clinic Portal
                </h1>
                <p className="text-slate-500">
                  Access your order tracking dashboard
                </p>
              </div>

              <div className="space-y-3">
                <Link to="/login" className="block">
                  <Button
                    size="lg"
                    className="w-full bg-[#0F766E] hover:bg-[#115E59] h-12"
                    data-testid="hero-login-btn"
                  >
                    <LogIn className="w-4 h-4 mr-2" />
                    Sign In to Dashboard
                  </Button>
                </Link>
                <Link to="/register" className="block">
                  <Button
                    size="lg"
                    variant="outline"
                    className="w-full border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626]/5 h-12"
                    data-testid="hero-register-btn"
                  >
                    <UserPlus className="w-4 h-4 mr-2" />
                    Register Your Clinic
                  </Button>
                </Link>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-100">
                <p className="text-xs text-slate-400 mb-3">Need help?</p>
                <div className="flex items-center justify-center gap-4 text-sm text-slate-500">
                  <a href="tel:4162509985" className="flex items-center gap-1 hover:text-[#0F766E] transition-colors">
                    <Phone className="w-3.5 h-3.5" />
                    (416) 250-9985
                  </a>
                  <span className="text-slate-300">|</span>
                  <a href="mailto:info@orthocanadalab.com" className="flex items-center gap-1 hover:text-[#0F766E] transition-colors">
                    <Mail className="w-3.5 h-3.5" />
                    Email Us
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          <p className="text-center text-xs text-slate-400 mt-6">
            503 Champagne Dr., North York ON M3J 2C6
          </p>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-white border-t border-slate-200 py-4">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-slate-500">
          &copy; {new Date().getFullYear()} Ortho Canada Lab
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
